var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.image},on:{"error":function($event){_vm.error = true},"load":_vm.loadHandler}})
}
var staticRenderFns = []

export { render, staticRenderFns }